import React from 'react'
import { LayoutProvider } from './component/layout/context/layoutcontext'
import Layout from './component/layout/Layout'
import { I18nextProvider } from 'react-i18next'
import i18n from '../src/locales/i18n' // i18next 설정 파일

function App() {
    return (
        <I18nextProvider i18n={i18n}>
            <LayoutProvider>
                <Layout>{<div>test1111111</div>}</Layout>
            </LayoutProvider>
        </I18nextProvider>
    )
}

export default App
